import { fetchPublicApi } from '@/lib/api/apiServiceBase.ts';
import { CreateWaitlistEntryDto } from '@/features/public/waitlist/types/CreateWaitlistEntryDto.ts';
import { CreateWaitlistEntryResponseDto } from '@/features/public/waitlist/types/CreateWaitlistEntryResponseDto.ts';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

const waitlistPublicApi = {
  createEntry: async (
    orgSlug: string,
    tourSlug: string,
    dto: CreateWaitlistEntryDto,
  ): Promise<CreateWaitlistEntryResponseDto> => {
    return fetchPublicApi<CreateWaitlistEntryResponseDto>(
      'POST',
      `public/organizers/${orgSlug}/tours/${tourSlug}/waitlist`,
      dto,
    );
  },
  getBasicTourInfo: async (
    orgSlug: string,
    tourSlug: string,
  ): Promise<BookingTourBasicDataDto> => {
    return fetchPublicApi<BookingTourBasicDataDto>(
      'GET',
      `public/organizers/${orgSlug}/tours/${tourSlug}/about`,
    );
  },
};

export default waitlistPublicApi;
